export default {"src":"/uk/_next/static/media/limitedCompanyIcon.c029f852.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};